import client from './client';
import type { SystemStatus, AppSettings } from '@/types';

export interface SettingsResponse {
  settings: AppSettings;
  stats: {
    user_count: number;
  };
}

export interface AdminUser {
  id: number;
  email: string;
  name: string;
  is_admin: boolean;
  created_at: string;
}

export interface UpdateUserInput {
  name?: string;
  email?: string;
  is_admin?: boolean;
}

export const settingsApi = {
  async getSystemStatus(): Promise<SystemStatus> {
    const response = await client.get<SystemStatus>('/settings/status');
    return response.data;
  },

  async getSettings(): Promise<SettingsResponse> {
    const response = await client.get<SettingsResponse>('/settings');
    return response.data;
  },

  async updateSetting(key: string, value: unknown): Promise<void> {
    await client.put('/settings', { key, value });
  },

  async toggleRegistration(): Promise<{ registration_enabled: boolean }> {
    const response = await client.post<{ registration_enabled: boolean }>('/settings/toggle-registration');
    return response.data;
  },

  async getUsers(): Promise<AdminUser[]> {
    const response = await client.get<{ data: AdminUser[] }>('/settings/users');
    return response.data.data;
  },

  async updateUser(id: number, data: UpdateUserInput): Promise<AdminUser> {
    const response = await client.put<{ user: AdminUser }>(`/settings/users/${id}`, data);
    return response.data.user;
  },

  async deleteUser(id: number): Promise<void> {
    await client.delete(`/settings/users/${id}`);
  },
};

export default settingsApi;
